export const convertToWav = async (webmBlob: Blob): Promise<Blob> => {
  const { FFmpeg } = await import('@ffmpeg/ffmpeg');
  const { fetchFile } = await import('@ffmpeg/util');

  const ffmpeg = new FFmpeg();
  await ffmpeg.load();

  const inputName = 'input.webm';
  const outputName = 'output.wav';

  await ffmpeg.writeFile(inputName, await fetchFile(webmBlob));

  await ffmpeg.exec(['-i', inputName, '-c:a', 'pcm_s16le', '-ar', '44100', outputName]);

  const outputData = await ffmpeg.readFile(outputName);
  const outputBlob = new Blob([outputData], { type: 'audio/wav' });

  return outputBlob;
};

export const isALACEncodedM4A = async (file: File): Promise<boolean> => {
  const { FFmpeg } = await import('@ffmpeg/ffmpeg');
  const { fetchFile } = await import('@ffmpeg/util');

  const ffmpeg = new FFmpeg();
  await ffmpeg.load();

  const inputName = 'input.m4a';
  await ffmpeg.writeFile(inputName, await fetchFile(file));

  try {
    await ffmpeg.exec(['-v', 'debug', '-i', inputName, '-f', 'null', '-']);

    const log = await ffmpeg.readFile('ffmpeg.log');
    const logText = new TextDecoder().decode(log as Uint8Array);

    const isALAC =
      logText.toLowerCase().includes('alac') ||
      logText.toLowerCase().includes('apple lossless') ||
      logText.toLowerCase().includes('codec: alac');
    return isALAC;
  } catch (error) {
    try {
      await ffmpeg.exec(['-i', inputName, '-c:a', 'aac', '-b:a', '256k', '-y', 'output.m4a']);
      return true;
    } catch (e) {
      return false;
    }
  }
};

export const convertM4AToAAC = async (file: File): Promise<File> => {
  const { FFmpeg } = await import('@ffmpeg/ffmpeg');
  const { fetchFile } = await import('@ffmpeg/util');

  const ffmpeg = new FFmpeg();
  await ffmpeg.load();

  const inputName = 'input.m4a';
  const outputName = 'output.m4a';

  await ffmpeg.writeFile(inputName, await fetchFile(file));

  await ffmpeg.exec(['-i', inputName, '-c:a', 'aac', '-b:a', '256k', '-y', outputName]);

  const outputData = await ffmpeg.readFile(outputName);
  const blob = new Blob([outputData as Uint8Array], { type: 'audio/x-m4a' });

  return new File([blob], file.name, {
    type: 'audio/x-m4a',
    lastModified: file.lastModified,
  });
};
